// Keep the header cart count in sync with AJAX cart changes. The theme's own
// updater targets `#site-control .cart` (not present in this custom header) and
// only fires on quantity edits, so the count went stale on upsell add/remove and
// needed a full page reload. This listens for theme:cartchanged and refreshes it.
(function () {
  if (window.__lgHeaderCartCountBound) return;
  window.__lgHeaderCartCountBound = true;

  function updateCartCount(count) {
    document.querySelectorAll('a[class*="cart-icon--"]').forEach((link) => {
      let countEl = link.querySelector('.lg-header__cart-count');
      const textEl = link.querySelector('.text-link');

      if (count > 0) {
        if (!countEl) {
          countEl = document.createElement('div');
          countEl.className = 'lg-header__cart-count';
          if (textEl) link.insertBefore(countEl, textEl);
          else link.appendChild(countEl);
        }
        countEl.textContent = count;
      } else if (countEl) {
        countEl.remove();
      }

      if (textEl) {
        const baseLabel = textEl.textContent.replace(/\s*\(\d+\)\s*$/, '').trim();
        textEl.textContent = count > 0 ? `${baseLabel} (${count})` : baseLabel;
      }
    });
  }

  document.addEventListener('theme:cartchanged', () => {
    fetch(`${window.Shopify.routes.root}cart.js`)
      .then((response) => (response.ok ? response.json() : null))
      .then((cart) => {
        if (cart) updateCartCount(cart.item_count);
      })
      .catch(() => {});
  });
})();

if (!customElements.get('lg-announcement-rotator')) {
  customElements.define(
    'lg-announcement-rotator',
    class LgAnnouncementRotator extends HTMLElement {
      connectedCallback() {
        this.messages = Array.from(this.querySelectorAll('.lg-header__announcement-message'));

        if (this.messages.length < 2) return;

        this.activeIndex = 0;
        this.classList.add('is-active');
        this.messages[0].classList.add('is-visible');

        this.interval = window.setInterval(() => {
          this.messages[this.activeIndex].classList.remove('is-visible');
          this.activeIndex = (this.activeIndex + 1) % this.messages.length;
          this.messages[this.activeIndex].classList.add('is-visible');
        }, 5000);
      }

      disconnectedCallback() {
        if (this.interval) {
          window.clearInterval(this.interval);
          this.interval = null;
        }
      }
    }
  );
}
